export const OPEN_HAMBURGER_MENU = "OPEN_HAMBURGER_MENU";

export const OPEN_SEARCHBAR = "OPEN_SEARCHBAR";
